import { langs } from "@/langs";

export const getLangFromPathname = (pathname: string | undefined) => {
  if (!pathname) return undefined; // some type errors were happening here for some reason
  const langInPathname = langs.find((l) => l === pathname.split("/")[1]);
  return langInPathname;
};
